<template>
	<div class="index">
		<!-- 左边的插画 -->
		<div class="bottom-left-image">
			<img style="height: 170px;" :src="left_image"/>
		</div>
		<!-- 右边的插画 -->
		<div class="bottom-right-image">
			<img style="height: 140px;" :src="right_image"/>
		</div>
		<!-- 内容区域 -->
		<div>
			<!-- 顶部图片、滚动 -->
			<BannerTop></BannerTop>
			<div class="flex-c" style="margin-top: 40px;">
				<div style="width: 1300px;">
					<NiceShop></NiceShop>
				</div>
			</div>
			<div class="flex-colume">
				<div class="top-title">
					<div class="title-bg">
						<!-- <hsimage :src="title_bg"></hsimage> -->
					</div>
					<div class="title very-big-title my-sans-font">{{ $t("HomeObject.hot") }}</div>

				</div>
				<!-- 热门活动卡片列表 -->
				<div class="list-content" style="margin-top: 40px;">
					<div class="list-item" v-for="(item, index) in activityDatas" :key="index">
						<activityCard :data="item" @itemClick="onActivityItemClick"></activityCard>
					</div>
				</div>
				<!-- 我的成绩 -->
				<div class="learn-star">
					<div style="display: flex; align-items: center; justify-content:space-between;">
						<div style="width: 60px;"></div>
						<div class="star-title-left very-big-title  my-sans-font">{{ $t("HomeObject.myscore") }} </div>
						<div class="star-title-right" @click="onClickMoreStar()">{{ $t("HomeObject.more") }}...</div>
					</div>
					<!-- 分割线 -->
					<div class="star-divider"></div>
				</div>
				<div class="list-content">
					<div class="list-item" v-for="(item, index) in learnstarDatas" :key="index">
						<starCard :data="item"></starCard>
					</div>
				</div>
				<!-- 以下空白，让界面更好看 -->
				<div style="height: 120px; background-color: transparent;"></div>
			</div>
		</div>
	</div>
</template>

<script>
	import activityCard from '@/components/index/activity_card.vue'
	import starCard from '@/components/index/star_card.vue'
	import BannerTop from '@/components/common/banner_top.vue'
	import NiceShop from '../niceshop/index.vue'
	import hsimage from '../../../components/common/hsimage.vue'

	export default {
		name: 'MainPage',
		components: {
			activityCard,
			starCard,
			NiceShop,
			BannerTop,
			hsimage
		},
		data() {
			return {

				left_image: require('../../../../static/images/mainpage/cao_left.png'),
				right_image: require('../../../../static/images/mainpage/yu_right.png'),
				activityDatas: [], // 热门活动数据
				learnstarDatas: [], // 我的成绩


			}
		},
		mounted() {
			this.$jq(window).scrollTop(0)
			setTimeout(() => {
				this.getActivityData()	
			}, 1000);
			setTimeout(() => {
				this.getStarList()	
			}, 1500);
			
		},
		deactivated() {
			this.activityDatas = []
		},
		methods: {


			onClickMoreStar() {
				// this.$emit('menuChanged','learnstar')
				// 直接跳转到 学习之星页面

				this.$router.push({
					name: 'learnstar'
				})
			},
			getActivityData() {
				this.$request.get('/content/listActivity', {}, {}, false).then(response => {
					// console.log('热门活动',response)
					if (response.data.code == 200) {
						this.activityDatas = response.data.rows
						// this.activityDatas.forEach(e=>{
						// 	e.pic='https://hansvision.com'+e.pic
						// })
					} else {
						this.activityDatas = []
					}
				}).catch(err => {
					console.log(err)
					this.activityDatas = []
				})
			},
			getStarList() {
				this.$request.get('/user/getStarUser', {}, false).then(response => {
					if (response.data.code == 200) {
						let list = response.data.rows
						let temp = list.sort((a, b) => {
							return b.points - a.points
						})
						if (temp.length > 8) {
							this.learnstarDatas = temp.slice(0, 7)
						} else {
							this.learnstarDatas = temp
						}

					} else {
						this.learnstarDatas = []
					}
				}).catch(err => {
					this.learnstarDatas = []
					console.log(err)
				})
			},
			onActivityItemClick(data) {
				// console.log('点击活动item',data.url)
				let link = data.outlink
				let url = data.url
				var routeUrl = url
				var id = undefined
				if (link == '2') {
					// 处理路径问题
					if (url.indexOf('?') > 0) {
						routeUrl = url.slice(0, url.indexOf('?'))
						id = url.slice(url.indexOf('?') + 4)
						console.log(routeUrl, id)
					}
					this.$router.push({
						name: routeUrl,
						params: {
							id: id
						}
					})
				} else {
					window.open("http://" + url, '_blank')
				}
			}
		}
	}
</script>

<style scoped>
	.flex-colume {
		display: flex;
		flex-direction: column;
		justify-content: flex-start;
		align-items: center;
	}

	.learn-star {
		margin: 80px 10%;
		width: 1300px;
	}

	.star-title-left {
		color: #0D556D;
		width: 140px;
		text-align: center;
		font-weight: bold;
	}

	.star-title-right {
		color: #888888;
		font-size: 16px;
		width: 60px;
		cursor: pointer;
	}

	.star-divider {
		margin-top: 10px;
		height: 2px;
		background-color: #FFB70A;
	}
</style>

<style scoped>
	.index {
		width: 100%;
		height: auto;
		min-height: 400px;
		background: linear-gradient(0deg, #7EBEFF 0%, #A0DCFF 100%);
		position: relative;
	}

	.bottom-left-image {
		position: absolute;
		width: 195px;
		height: 140px;
		left: 0px;
		bottom: 0px;
		overflow: hidden;
	}

	.bottom-right-image {
		position: absolute;
		width: 195px;
		height: 100px;
		right: 0px;
		bottom: 0px;
		overflow: hidden;
	}


	/* 内容区域 */
	.top-pageview {
		height: 360px;
		width: 100%;
		/* background-color: #47B8B4; */
	}

	.top-title {
		position: relative;
		display: flex;
		align-items: center;
		justify-content: center;
		margin-top: 30px;
	}

	.title-bg {
		position: absolute;
		top: 12px;
	}

	.title {
		color: #0D556D;
		font-weight: bold;
	}

	.list-content {
		margin-left: 40px;
		display: flex;
		flex-wrap: wrap;
		flex-direction: row;
		width: 1240px;
	}
</style>



// WEBPACK FOOTER //
// src/views/hanscourse/mainpage/index.vue